import React from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import { AddOrder, AddPayouts, AddProducts, AddTransactions, TransactionImportProgress, Brand, BrandsList, CreateBrand, CreateEmployee, CreateOutbound, CreateWarehouse, DuePayouts, EmployeesList, Home, IMSAdminHome, IMSEmployeeHome, IMSEmployeeOrders, InboundsList, InboundsByBrand, ItemUpdateProgress, ItemUpdateHistory, LoginIMSAdmin, LoginIMSEmployee, LoginWHFinance, LoginIMSWarehouseStaff, Order, OrdersList, OutboundSuccess, PackOrder, PackingSystem, Payouts, ProductsList, ReceiveInbounds, RegisterIMS, Transactions, UnpaidOrders, WHFinanceHome, Warehouse, WarehousesList, IMSWarehouseStaffHome, WHProductsList, WHAddProducts, WHCreateOutbound, WHInboundsList, WHReceiveInbounds, WHWarehousesList, WHWarehouse, WHOrdersList, WHOrder, WHEmployeesList, WHCreateEmployee, WHPackingSystem, WHActionCenter, WHOutboundSuccess, WHItemUpdateProgress, WHItemUpdateHistory, AddFees, PrintInvoices, FeesAndCompensations, ServiceFeeTiers, BrandServiceFees, CreateInboundRTO, TakeActionRTO, Vendors, VendorDetails, StockRecount, StockRecountProgress, StockRecountsList } from "./Pages";
import ProtectedRoute from "./ProtectedRoute";
import { FinanceTierAccessRoute } from "./financeTierAccess";
import FinanceShell from "./Pages/WHFinance/FinanceShell";
import ChartOfAccounts from "./Pages/WHFinance/ChartOfAccounts";
import Memberships from "./Pages/WHFinance/Memberships";
import OverstockCalculator from "./Pages/WHFinance/OverstockCalculator";
import TransactionAnalysis from "./Pages/WHFinance/TransactionAnalysis";
import Expenses from "./Pages/WHFinance/Expenses";
import CashAndBank from "./Pages/WHFinance/CashAndBank";
import FinancialReports from "./Pages/WHFinance/FinancialReports";
import AuditLog from "./Pages/WHFinance/AuditLog";
import InvoiceRegister from "./Pages/WHFinance/InvoiceRegister";
import PayoutWorkflow from "./Pages/WHFinance/PayoutWorkflow";
import DuePayoutBoard from "./Pages/WHFinance/DuePayoutBoard";
import { ActionCenter, ApprovalInboundsList, NotificationsList, CreateNotification, ShippingServicesList, CreateShippingService, BazaarsDashboard, BazaarAdminDetail, BazaarSendStock, OutboundsList, TicketsList } from "./Pages/IMSAdmin";
import PosExternalRedirect from "./Pages/Cashier/PosExternalRedirect";

export const Router = () => {
  return (
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/register" exact element={<RegisterIMS />} />
      <Route path="/login" exact element={<LoginIMSAdmin />} />
      <Route exact element={<ProtectedRoute allowed={["InventoryAdmin"]} />}>
        <Route path="/ims/admin" exact element={<IMSAdminHome />} />
        <Route path="/ims/admin/products" exact element={<ProductsList />} />
        <Route path="/ims/admin/products/add" exact element={<AddProducts />} />
        <Route path="/ims/admin/outbounds" exact element={<OutboundsList />} />
        <Route path="/ims/admin/outbounds/create" exact element={<CreateOutbound />} />
        <Route path="/ims/admin/outbounds/success/:outboundId" exact element={<OutboundSuccess />} />
        <Route path="/ims/admin/stock-recount" exact element={<StockRecount />} />
        <Route path="/ims/admin/stock-recount/history" exact element={<StockRecountsList />} />
        <Route path="/ims/admin/stock-recount/progress/:taskId" exact element={<StockRecountProgress />} />
        <Route path="/ims/admin/inbounds" exact element={<InboundsList />} />
        <Route path="/ims/admin/inbounds/by-brand" exact element={<InboundsByBrand />} />
        <Route path="/ims/admin/item-updates" exact element={<ItemUpdateHistory />} />
        <Route path="/ims/admin/item-updates/:taskId" exact element={<ItemUpdateProgress />} />
        <Route path="/ims/admin/inbounds/receive/:warehouseId" exact element={<ReceiveInbounds />} />
        <Route path="/ims/admin/inbounds/pending" exact element={<ApprovalInboundsList />} />
        <Route path="/ims/admin/warehouses" exact element={<WarehousesList />} />
        <Route path="/ims/admin/warehouse/:warehouseId" exact element={<Warehouse />} />
        <Route path="/ims/admin/warehouses/create" exact element={<CreateWarehouse />} />
        <Route path="/ims/admin/tickets" exact element={<TicketsList />} />
        <Route path="/ims/admin/orders" exact element={<OrdersList />} />
        <Route path="/ims/admin/order/:orderId" exact element={<Order />} />
        <Route path="/ims/admin/orders/add" exact element={<AddOrder />} />
        <Route path="/ims/admin/employees" exact element={<EmployeesList />} />
        <Route path="/ims/admin/employees/create" exact element={<CreateEmployee />} />
        <Route path="/ims/admin/packing" exact element={<PackingSystem />} />
        <Route path="/ims/admin/brands" exact element={<BrandsList />} />
        <Route path="/ims/admin/brands/create" exact element={<CreateBrand />} />
        <Route path="/ims/admin/brand/:brandId" exact element={<Brand />} />
        <Route path="/ims/admin/notifications" exact element={<NotificationsList />} />
        <Route path="/ims/admin/notifications/create" exact element={<CreateNotification />} />
        <Route path="/ims/admin/action-center" exact element={<ActionCenter />} />
        <Route path="/ims/admin/shipping-services" exact element={<ShippingServicesList />} />
        <Route path="/ims/admin/shipping-services/create" exact element={<CreateShippingService />} />
        <Route path="/ims/admin/inbounds/rto/create" exact element={<CreateInboundRTO />} />
        <Route path="/ims/admin/inbounds/rto/action/:orderId" exact element={<TakeActionRTO />} />
        <Route path="/ims/admin/bazaars" exact element={<BazaarsDashboard />} />
        <Route path="/ims/admin/bazaars/:id" exact element={<BazaarAdminDetail />} />
        <Route path="/ims/admin/bazaars/:id/send-stock" exact element={<BazaarSendStock />} />
      </Route>
      <Route path="/ims/cashier/login" exact element={<PosExternalRedirect path="/login" />} />
      <Route path="/ims/cashier/pos" exact element={<PosExternalRedirect path="/" />} />
      <Route path="/ims/cashier/*" exact element={<PosExternalRedirect path="/" />} />
      <Route path="/ims/warehouse-staff/login" exact element={<LoginIMSWarehouseStaff />} />
      <Route exact element={<ProtectedRoute allowed={["WarehouseStaff"]} />}>
        <Route path="/ims/warehouse-staff" exact element={<IMSWarehouseStaffHome/>} />
        <Route path="/ims/warehouse-staff/products" exact element={<WHProductsList />} />
        <Route path="/ims/warehouse-staff/outbounds/create" exact element={<WHCreateOutbound />} />
        <Route path="/ims/warehouse-staff/outbounds/success/:outboundId" exact element={<WHOutboundSuccess />} />
        <Route path="/ims/warehouse-staff/inbounds" exact element={<WHInboundsList />} />
        <Route path="/ims/warehouse-staff/item-updates" exact element={<WHItemUpdateHistory />} />
        <Route path="/ims/warehouse-staff/item-updates/:taskId" exact element={<WHItemUpdateProgress />} />
        <Route path="/ims/warehouse-staff/inbounds/receive/:warehouseId" exact element={<WHReceiveInbounds />} />
        <Route path="/ims/warehouse-staff/warehouses" exact element={<WHWarehousesList />} />
        <Route path="/ims/warehouse-staff/warehouse/:warehouseId" exact element={<WHWarehouse />} />
        <Route path="/ims/warehouse-staff/orders" exact element={<WHOrdersList />} />
        <Route path="/ims/warehouse-staff/order/:orderId" exact element={<WHOrder />} />
        <Route path="/ims/warehouse-staff/employees" exact element={<WHEmployeesList />} />
        <Route path="/ims/warehouse-staff/employees/create" exact element={<WHCreateEmployee />} />
        <Route path="/ims/warehouse-staff/packing" exact element={<WHPackingSystem />} />
        <Route path="/ims/warehouse-staff/action-center" exact element={<WHActionCenter />} />
      </Route>
      <Route path="/ims/employee/login" exact element={<LoginIMSEmployee />} />
      <Route exact element={<ProtectedRoute allowed={["InventoryEmployee"]} />}>
        <Route path="/ims/employee" exact element={<IMSEmployeeHome />} />
        <Route path="/ims/employee/orders" exact element={<IMSEmployeeOrders />} />
        <Route path="/ims/employee/order/:orderId" exact element={<PackOrder />} />
      </Route>
      <Route element={<FinanceShell />}>
      <Route path="/warehousing/finance/login" exact element={<LoginWHFinance />} />
      <Route exact element={<ProtectedRoute allowed={["Finance"]} />}>
        <Route path="/warehousing/finance" exact element={<WHFinanceHome />} />
        <Route path="/warehousing/finance/transactions" exact element={<Transactions />} />
        <Route path="/warehousing/finance/transactions/add" exact element={<AddTransactions />} />
        <Route path="/warehousing/finance/transactions/import/progress/:taskId" exact element={<TransactionImportProgress />} />
        <Route path="/warehousing/finance/orders" exact element={<UnpaidOrders />} />
        <Route path="/warehousing/finance/payouts" exact element={<Payouts />} />
        <Route path="/warehousing/finance/payouts/due" exact element={<DuePayouts />} />
        <Route path="/warehousing/finance/payouts/add" exact element={<AddPayouts />} />
        <Route path="/warehousing/finance/fees-compensations" exact element={<FeesAndCompensations />} />
        <Route path="/warehousing/finance/fees" exact element={<AddFees />} />
        <Route path="/warehousing/finance/fees/register" exact element={<Navigate to="/warehousing/finance/fees-compensations" replace />} />
        <Route path="/warehousing/finance/compensations" exact element={<Navigate to="/warehousing/finance/fees-compensations" replace />} />
        <Route path="/warehousing/finance/invoices" exact element={<PrintInvoices />} />
        <Route path="/warehousing/finance/invoice-register" exact element={<FinanceTierAccessRoute><InvoiceRegister /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/payouts/workflow" exact element={<FinanceTierAccessRoute><PayoutWorkflow /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/payouts/due-board" exact element={<FinanceTierAccessRoute><DuePayoutBoard /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/accounts" exact element={<FinanceTierAccessRoute><ChartOfAccounts /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/memberships" exact element={<FinanceTierAccessRoute><Memberships /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/overstock" exact element={<FinanceTierAccessRoute><OverstockCalculator /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/analysis" exact element={<FinanceTierAccessRoute><TransactionAnalysis /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/expenses" exact element={<FinanceTierAccessRoute><Expenses /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/cash-bank" exact element={<FinanceTierAccessRoute><CashAndBank /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/reports" exact element={<FinanceTierAccessRoute><FinancialReports /></FinanceTierAccessRoute>} />
        <Route path="/warehousing/finance/audit" exact element={<AuditLog />} />
        <Route
          path="/warehousing/finance/service-fee-tiers"
          exact
          element={
            <FinanceTierAccessRoute>
              <ServiceFeeTiers />
            </FinanceTierAccessRoute>
          }
        />
        <Route
          path="/warehousing/finance/brand-service-fees"
          exact
          element={
            <FinanceTierAccessRoute>
              <BrandServiceFees />
            </FinanceTierAccessRoute>
          }
        />
        <Route path="/warehousing/finance/vendors" exact element={<Vendors />} />
        <Route path="/warehousing/finance/vendors/:vendorId" exact element={<VendorDetails />} />
      </Route>
      </Route>
    </Routes>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Router);
